export default "__VITE_ASSET__CMeWICfd__"